import { cn } from '../../lib/utils';

const GRADIENTS = [
  'from-emerald-400 to-teal-600',
  'from-blue-400 to-indigo-600',
  'from-violet-400 to-purple-600',
  'from-rose-400 to-pink-600',
  'from-amber-400 to-orange-500',
  'from-cyan-400 to-sky-600',
  'from-lime-400 to-green-600',
  'from-fuchsia-400 to-pink-600',
];

function pickGradient(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return GRADIENTS[h % GRADIENTS.length];
}

interface GradientAvatarProps {
  name: string;
  avatarUrl?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  shape?: 'circle' | 'rounded';
  gradient?: string;
  className?: string;
}

const SIZE_CLS = {
  xs: 'h-6 w-6 text-[9px]',
  sm: 'h-8 w-8 text-[11px]',
  md: 'h-10 w-10 text-xs',
  lg: 'h-11 w-11 text-sm',
};

const SHAPE_CLS = {
  circle: 'rounded-full',
  rounded: 'rounded-xl',
};

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function GradientAvatar({
  name,
  avatarUrl,
  size = 'md',
  shape = 'circle',
  gradient,
  className,
}: GradientAvatarProps) {
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={cn(
          'shrink-0 object-cover shadow-sm',
          SIZE_CLS[size],
          SHAPE_CLS[shape],
          className,
        )}
      />
    );
  }

  const g = gradient ?? pickGradient(name);
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center bg-gradient-to-br font-bold text-white shadow-sm',
        SIZE_CLS[size],
        SHAPE_CLS[shape],
        g,
        className,
      )}
    >
      {getInitials(name)}
    </div>
  );
}
